import { keys } from '../../config/keys';
import storageService from './storageService';

const TokenService = {
  /**
   * Stores a token in localStorage.
   * @param value - The token value to store.
   * @returns A promise that resolves if the token is stored successfully.
   */
  storeToken: async (value: string): Promise<void> => {
    if (!value) {
      throw new Error('A token value is required to store a token.');
    }
    try {
      await storageService.storeValue(keys.token, value);
    } catch (error: any) {
      throw new Error(`Failed to store token: ${error.message}`);
    }
  },

  /**
   * Retrieves a stored token from localStorage.
   * @returns A promise that resolves with the token value, or `null` if not found.
   */
  getToken: async (): Promise<string | null> => {
    try {
      return await storageService.getValue(keys.token);
    } catch (error: any) {
      throw new Error(`Failed to retrieve token: ${error.message}`);
    }
  },

  /**
   * Removes a stored token from localStorage.
   * @returns A promise that resolves if the token is removed successfully.
   */
  removeToken: async (): Promise<void> => {
    try {
      await storageService.removeValue(keys.token);
    } catch (error: any) {
      throw new Error(`Failed to remove token: ${error.message}`);
    }
  },
};

export default TokenService;
